import SchoolExamPeriodClassDetailAPI from '@/apis/business/teacher/school-exam-period-class-detail-api.js'
import { localStorageKeys } from '@/common/storage-keys'
import { localStorage } from '@/utils/storage'

export default {
  namespaced: true,

  state: {
    schoolExamPeriodClassDetails: null,
    schoolExamPeriodClassDetail: null
  },

  getters: {
  },

  mutations: {
    /**
     * Clone dữ liệu kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriodClassDetails (state, data) {
      state.schoolExamPeriodClassDetails = data
    },
    /**
     * Dữ liệu chi tiết một bản ghi kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriodClassDetail (state, data) {
      state.schoolExamPeriodClassDetail = data
    }
  },

  actions: {
    /**
     * Lấy chi tiết kỳ đánh giá của 1 lớp
     * @param {*} context
     * @param {*} param
     * VHSON 01/04/2022
     */
    getSchoolExamPeriodClassDetail (context, param) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodClassDetailAPI.getAsync('detail?id=' + param)
          .then((res) => {
            context.commit('setSchoolExamPeriodClassDetail', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách kỳ đánh giá của 1 lớp theo schoolExamPeriodDetailId
     * @param {*} context
     * @param {*} param
     * VHSON 01/04/2022
     */
    getSchoolExamPeriodClassDetails (context, param) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodClassDetailAPI.getAsync('list?schoolExamPeriodDetailID=' + param)
          .then((res) => {
            context.commit('setSchoolExamPeriodClassDetails', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }

  }
}
